<template>
  <div class="layout--full-page">
    <div
      class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
      id="page-login"
    >
      <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
        <vx-card>
          <div slot="no-body" class="full-page-bg-color">
            <div class="vx-row no-gutter justify-center items-center">
              <div class="vx-col hidden lg:block lg:w-1/2">
                <img src="/logo.png" alt="reset-password" class="mx-auto" width="200px" />
              </div>
              <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
                <div class="p-8 login-tabs-container">
                  <div class="vx-card__title mb-4">
                    <h4 class="mb-4">Reset Password</h4>
                    <p>Silahkan isi form dibawah untuk melakukan penggantian password</p>
                  </div>
                  <div>
                    <vs-input
                      type="password"
                      name="password"
                      icon-no-border
                      icon="icon icon-lock"
                      icon-pack="feather"
                      label-placeholder="Password"
                      v-model="auth.password"
                      class="w-full mt-6"
                      val-icon-danger="icon-x"
                      val-icon-pack="feather"
                    />
                    <vs-input
                      type="password"
                      name="password"
                      icon-no-border
                      icon="icon icon-lock"
                      icon-pack="feather"
                      label-placeholder="Password Confirm"
                      v-model="auth.password_confirmation"
                      class="w-full mt-6"
                      v-on:keyup.enter="login"
                      val-icon-danger="icon-x"
                      val-icon-pack="feather"
                    />
                    <div class="flex flex-wrap justify-between my-5">
                      <vs-button class="float-right" @click="reset">Reset Password</vs-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      auth : {
        password: '',
        password_confirmation : '',
      },
      isAlertShown: false
    };
  },
  methods: {
    reset(){
      var self = this;
      self.$vs.loading();
      self.$http
      .post(`/app/auth/reset-password/${self.$route.params.token}`, self.auth)
      .then(() => {
        self.$vs.notify({
          title: 'Selamat, password berhasil di ganti !',
          color: "success",
          iconPack: "feather",
          icon: "icon-check"
        });
        window.setTimeout(function(){ 
          self.$router.push({ name: "login" });
        },700);
      })
      .catch(e => {
        if (e.response.status == 422) {
          let error = e.response.data.data.errors;
          self.setMessageError(error);
        } else {
          self.parseError(e);
        }
      })
      .finally(() => {
        self.$vs.loading.close();
      });
    },
    setMessageError(error) {
      for (var key in error) {
        if (!error.hasOwnProperty(key)) continue;
        let msgs = error[key];
        this.$vs.notify({
            title: msgs.join(". "),
            color: "danger",
            iconPack: "feather",
            icon: "icon-x",
            position : "top-right"
        });
      }
    },
  }
};
</script>
<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1;
    }
    .bg-twitter {
      background-color: #00aaff;
    }
    .bg-google {
      background-color: #4285f4;
    }
    .bg-github {
      background-color: #333;
    }
  }
}
</style>